import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { LanguageService } from 'src/app/components/admin/points-interest/services/language.service';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { AgentService } from 'src/app/components/admin/partners/services/partner.service';
import { TokenService } from 'src/app/core/auth/services/token.service';
import { SiteModel } from 'src/app/components/admin/site/models/site.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  idioma: string;
  languages: any;
  currentFlag = { displayName: '', icon: '' };
  defualtLanguage = 'pt-br';
  agencySite: any;
  isHidden: boolean;
  agencyInfo: SiteModel;
  isMobile = false;

  constructor(private authService: AuthService,
    private router: Router,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private agentService: AgentService,
    private tokenService: TokenService,
    private deviceDetector: DeviceDetectorService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.isMobile = (this.deviceDetector.isMobile() || this.deviceDetector.isTablet());
    this.isHidden = true;

    const stored = localStorage.getItem('lang') || this.defualtLanguage;
    this.useLanguage({ id: null, codeIso: stored });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.idioma = event.lang;
      this.setHtmlAttrs(event.lang);
      this.configureLanguage();
    });

    this.configureLanguage();
    this.configureSite();
  }

  configureSite() {
    const personId = this.tokenService.getToken(this.tokenService.TOKEN_PERSON_ID);
    const role = this.tokenService.getToken(this.tokenService.TOKEN_ROLE);

    if (role !== 'AGENT' || !personId) {
      return;
    }

    this.agentService.getAgentByPerson(personId).pipe(
      switchMap((agentResult) => {
        if (!agentResult?.success || !agentResult.data?.id) {
          return of(null);
        }

        return this.agentService.getAgency(agentResult.data.id);
      })
    ).subscribe((result) => {
      if (result?.success) {
        this.agencyInfo = Object.assign({}, result.data);
        this.agencySite = this.agencyInfo?.agencySite;
        this.isHidden = false;
        this.tokenService.createToken(this.tokenService.PARTNER_SITE, this.agencySite);
      }
    });
  }

  sair() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  useLanguage(lang: any): void {
    if (lang?.id) this.languageService.setLanguageId(lang.id);
    const code = lang.codeIso;
    this.translateService.use(code);
    localStorage.setItem('lang', code);
    this.idioma = code;
    this.currentFlag = lang;
    this.setHtmlAttrs(code);
  }

  private setHtmlAttrs(code: string) {
    const html = this.document.documentElement;
    html.setAttribute('lang', code);
    html.setAttribute('translate', 'no');
    html.classList.add('notranslate');
  }

  public configureLanguage() {
    const languageStorage = sessionStorage.getItem('languages');
    this.idioma = this.translateService.currentLang || localStorage.getItem('lang') || this.defualtLanguage;
    if (languageStorage) {
      this.languages = JSON.parse(languageStorage);
      this.languages?.map((item: any) => item.icon = `assets/img/${item.icon}`);
      this.currentFlag = this.languages?.find((item: any) => item.codeIso == this.idioma);
    }
  }
}
